export const CHANGE_VIEW = 'CHANGE_VIEW';

const changeView = (state = {}, action) => {
    const { type = null } = action;

    if (type === CHANGE_VIEW) {
        return Object.assign({}, state, action.viewtype);
    }

    return state;
};

export default changeView;
